module.exports = __webpack_public_path__ + "img/chain10.64cfafca.png";